import { render, staticRenderFns } from "./StudentSpecialResource.vue?vue&type=template&id=42761bff"
import script from "./StudentSpecialResource.vue?vue&type=script&lang=js"
export * from "./StudentSpecialResource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports